import { render, staticRenderFns } from "./NavBarUser.vue?vue&type=template&id=395cfd4e&scoped=true&"
import script from "./NavBarUser.vue?vue&type=script&lang=js&"
export * from "./NavBarUser.vue?vue&type=script&lang=js&"
import style0 from "styles/components/navbaruser.css?vue&type=style&index=0&id=395cfd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395cfd4e",
  null
  
)

export default component.exports